import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { ErrorBoundary, PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import { mfeLazyLoadErrorHandler } from 'utils/mfe';
import { store, context } from '../../store';

const EServicesIndex = React.lazy(() => importRemote<any>({
  url: getMfeUrl('ESERVICES_INDEX'),
  scope: 'EServicesIndex',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadErrorHandler));

interface IEServicesIndexWrapperProps {
  navbarLoaded?: boolean
}

export default function EServicesIndexWrapper({
  navbarLoaded,
}: IEServicesIndexWrapperProps) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <ErrorBoundary>
        <EServicesIndex store={store} context={context} />
      </ErrorBoundary>
    </Suspense>
  );
}
